module.exports = __webpack_public_path__ + "static/img/winter_shibingPic.57df0b36.png";